import React from "react";
import ContactBarSection from "../components/ContactBar";
import DonateSection from "../components/DonateBar";
import NewsletterSection from "../components/NewsletterBar";
import i18n from 'i18next';

import ProjectSection from "../components/ProjectSection";
import { joinObj1, joinObj2, joinObj3, joinObj4, joinObj1fr, joinObj2fr, joinObj3fr, joinObj4fr  } from "../components/ProjectSection/data";

const Join = () => {
  const lang = i18n.language;
  if(lang === "fr"  || lang === "fr-FR"){
    return ( 
    <>
      <ProjectSection {...joinObj1fr} />
      <ContactBarSection isLight={true} />
      <ProjectSection {...joinObj2fr} />
      <ContactBarSection isLight={false} />
      <ProjectSection {...joinObj3fr} />
      <DonateSection isDiv={false} />
      <ProjectSection {...joinObj4fr} />
      <NewsletterSection />
      <div className="illustrations">
        Illustrations par <a href="https://icons8.com/illustrations/author/eEbrZFlkyZbD">Anna Antipina</a>,{" "}
        <a href="https://icons8.com/illustrations/author/u7l2K4BCiAa9">Natasha Remarchuk</a>,{" "}
        <a href="https://icons8.com/illustrations/author/HxMFjfKZdNq2">Rosina Gavrilash</a> et{" "}
        <a href="https://icons8.com/illustrations/author/oZpGJx8ts63Q">Thierry Fousse</a> de <a href="https://icons8.com/illustrations">Ouch!</a>
      </div>
    </>
    );
  }else{

  return (
    <>
      <ProjectSection {...joinObj1} />
      <ContactBarSection isLight={true} />
      <ProjectSection {...joinObj2} />
      <ContactBarSection isLight={false} />
      <ProjectSection {...joinObj3} />
      <DonateSection isDiv={false} />
      <ProjectSection {...joinObj4} />
      <NewsletterSection />
      <div className="illustrations">
        Illustrations by <a href="https://icons8.com/illustrations/author/eEbrZFlkyZbD">Anna Antipina</a>,{" "}
        <a href="https://icons8.com/illustrations/author/u7l2K4BCiAa9">Natasha Remarchuk</a>,{" "}
        <a href="https://icons8.com/illustrations/author/HxMFjfKZdNq2">Rosina Gavrilash</a> and{" "}
        <a href="https://icons8.com/illustrations/author/oZpGJx8ts63Q">Thierry Fousse</a> from <a href="https://icons8.com/illustrations">Ouch!</a>
      </div>
    </>
  );
}
};

export default Join;
